import { fadeAnimation } from "./fade-animation";
import { foldAnimation } from "./fold-animation";
import {
    slideInAnimation,
    slideInAnimationWithMargin,
    slideInOutAnimation,
    slideInSideOffScreenDown,
    slideInSideOffScreenRight,
    slideInSideOffScreenUp,
} from "./slide-in-animation";

export const AnimationUtils = {
    slideInAnimation,
    slideInAnimationWithMargin,
    foldAnimation,
    fadeAnimation,
    slideInSideOffScreenRight,
    slideInSideOffScreenDown,
    slideInSideOffScreenUp,
    slideInOutAnimation,
};
